import Cookies from "js-cookie";

export const SIMLY_PARTNER_API_URL = process.env.REACT_APP_API_URL as string;
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY as string;

export const getAccessToken = (): string | undefined => {
    return Cookies.get('token');
}
